var _defs, _g, _polygon, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIconsMousebuttonMove(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #202346;\n        stroke-width: .75px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #d3343f;\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        stroke: #fff;\n        stroke-width: .5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m15.1,23.59c0,.93,4.39,1.68,9.81,1.68v-11.32l-4.74,1.2-3.02,2.27-1.53,3.56-.52,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.1,38.27c0,5.32,4.39,9.64,9.81,9.64s9.81-4.31,9.81-9.64c0,0,0-14.67,0-14.67,0-5.32-4.39-9.64-9.81-9.64s-9.81,4.31-9.81,9.64c0,0,0,14.67,0,14.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.91,25.28c5.42,0,9.81-.75,9.81-1.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.1,23.59c0,.93,4.39,1.68,9.81,1.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.92,28.38c-1.07,0-1.94-.85-1.94-1.9v-5.34c0-1.05.87-1.9,1.94-1.9s1.94.85,1.94,1.9v5.34c0,1.05-.87,1.9-1.94,1.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.88,
    y1: 26.75,
    x2: 25.95,
    y2: 26.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.88,
    y1: 25.28,
    x2: 25.95,
    y2: 25.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.88,
    y1: 23.8,
    x2: 25.95,
    y2: 23.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.88,
    y1: 22.33,
    x2: 25.95,
    y2: 22.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.88,
    y1: 20.86,
    x2: 25.95,
    y2: 20.86
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "21.8 7.48 20.84 6.58 24.92 2.1 28.99 6.58 28.03 7.48 25.58 4.77 25.58 12.47 24.26 12.47 24.26 4.77 21.8 7.48"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "8.31 26.71 7.41 27.67 2.92 23.59 7.41 19.52 8.31 20.48 5.59 22.94 13.29 22.94 13.29 24.26 5.59 24.26 8.31 26.71"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.69 20.48 42.59 19.52 47.08 23.6 42.59 27.67 41.69 26.71 44.41 24.25 36.71 24.25 36.71 22.93 44.41 22.93 41.69 20.48"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIconsMousebuttonMove);
export default __webpack_public_path__ + "static/media/help_icons_mousebutton_move.dc8f395d5cc32229a3484e6872bbe590.svg";
export { ForwardRef as ReactComponent };